<template>
  <div class="global-help-tab w-100">
    <div class="ap-title ap-title__main px-3 pt-3 pb-2">
      <span>{{ $t('component.shortcutsModal.globals') }}</span>
    </div>
    <div class="px-3">
      <shortcuts-and-voice-commands-table :table-data="globalShortcuts" />
    </div>
  </div>
</template>

<script>
import ShortcutsAndVoiceCommandsTable from '@/components/help/shortcutsAndVoiceCommands/ShortcutsAndVoiceCommandsTable'

export default {
    name: 'GlobalHelpTab',
    components: {
        ShortcutsAndVoiceCommandsTable
    },
    data() {
        return {
            globalShortcuts: [
                {
                    tableTitle: this.$tc('component.shortcutsModal.labels.title.globalTitle'),
                    tableElements: [
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.extendOrContractSidebar'),
                            shortcuts: [
                                { key: 'F1' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.toggleSidebar')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.signOut'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'F1' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.signOut')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.userConfiguration'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'U' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.configuration')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.closeAdditionalSidepanel'),
                            shortcuts: [
                                { key: 'Shift' },
                                { key: 'Esc' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.closeAdditionalSidepanel')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.cleanFilters'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Alt' },
                                { key: 'F' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.cleanFilters')
                        }
                    ]
                },
                {
                    tableTitle: this.$tc('component.shortcutsModal.labels.title.globalLocator'),
                    tableElements: [
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.globalLocator'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'F' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.globalLocator')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToRegistry'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'R' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToRegistry')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToGrossing'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'G' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToGrossing')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToCytology'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'C' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToCytology')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToDiagnosis'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'D' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToDiagnosis')
                        },
                        {
                            action: this.$t('component.shortcutsModal.labels.action.pathologicalReport'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'V' }
                            ],
                            voiceCommand: this.$t('component.shortcutsModal.labels.voice.pathologicalReport')
                        }
                    ]
                },
                {
                    tableTitle: this.$tc('component.shortcutsModal.labels.title.globalBreadcrumbs'),
                    tableElements: [
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToRegistry'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'R' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToRegistry')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToGrossing'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'G' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToGrossing')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToCytology'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'C' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToCytology')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.goToDiagnosis'),
                            shortcuts: [
                                { key: 'Ctrl' },
                                { key: 'Shift' },
                                { key: 'D' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.goToDiagnosis')
                        }
                    ]
                },
                {
                    tableTitle: this.$tc('component.shortcutsModal.labels.title.globalDialog'),
                    tableElements: [
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.yesDialog'),
                            shortcuts: [
                                { key: 'far fa-level-down', icon: true }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.yesDialog')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.noDialog'),
                            shortcuts: [
                                { key: this.$t('component.shortcutsModal.delKey') }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.noDialog')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.saveDialog'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'S' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.saveDialog')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.noSaveDialog'),
                            shortcuts: [
                                { key: 'Alt' },
                                { key: 'N' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.noSaveDialog')
                        },
                        {
                            action: this.$tc('component.shortcutsModal.labels.action.cancelDialog'),
                            shortcuts: [
                                { key: 'Esc' }
                            ],
                            voiceCommand: this.$tc('component.shortcutsModal.labels.voice.cancelDialog')
                        }
                    ]
                }
            ]
        }
    }
}
</script>
